<template>
  <section class="settings-card">
    <h3 v-if="header" class="settings-card__header">{{ header }}</h3>
    <div class="settings-card__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "SettingsCard",
  props: {
    header: { type: String, default: "" },
  },
};
</script>

<style scoped>
.settings-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-card__header {
  margin: 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--app-text-muted);
  text-transform: uppercase;
}

.settings-card__body {
  display: flex;
  flex-direction: column;
  background: var(--app-surface);
  border: 1px solid var(--app-border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--app-shadow);
}

.settings-card__body :deep(.settings-row + .settings-row) {
  border-top: 1px solid var(--app-border);
}
</style>
